module.exports = __webpack_public_path__ + "img/mannul_request_help-status.ffe2affc.png";